(function() {
  const init = function() {
    // js/custom-element/section/product-facet/product-facet.js
    // LEONARDO: "Ausverkaufte ans Ende" fuer Kundensortierungen (Bestseller, Preis, Suche ...).
    // Siehe snippets/oos-last-data.liquid. Bei "Empfohlen" (manuell) sortiert die n8n-Engine.
    var ProductFacet = class extends CustomHTMLElement {
      connectedCallback() {
        this.delegate.on("pagination:page-changed", this._rerender.bind(this));
        this.delegate.on("facet:criteria-changed", this._rerender.bind(this));
        this.delegate.on("facet:abort-loading", this._abort.bind(this));
        if (this.hasAttribute("data-oos-split") && this._oosShouldSplit(window.location.href)) {
          this._rerender({ detail: { url: window.location.href }, oosInitial: true });
        } else {
          this.setAttribute("data-oos-ready", "");
        }
      }
      _oosShouldSplit(href) {
        const url = new URL(href, window.location.origin);
        if (url.searchParams.has("filter.v.availability")) {
          return false;
        }
        if (url.pathname.indexOf("/search") === 0) {
          return true;
        }
        const sortBy = url.searchParams.get("sort_by");
        return !!sortBy && sortBy !== "manual";
      }
      async _oosFetch(href, extraParams) {
        const url = new URL(href, window.location.origin);
        url.searchParams.set("section_id", this.getAttribute("section-id"));
        Object.keys(extraParams || {}).forEach((key) => url.searchParams.set(key, extraParams[key]));
        const response = await fetch(url.toString(), { signal: this.abortController.signal });
        const div = document.createElement("div");
        div.innerHTML = await response.text();
        return div;
      }
      _oosItems(div) {
        return Array.from(div.querySelectorAll(".product-list__inner > product-item"));
      }
      async _oosApply(fakeDiv, href) {
        const dataElement = fakeDiv.querySelector("script[data-oos-last]");
        if (!dataElement) {
          return;
        }
        let data;
        try {
          data = JSON.parse(dataElement.textContent);
        } catch (e) {
          return;
        }
        const available = data.available, total = data.total, pageSize = data.pageSize;
        const unavailable = total - available;
        if (data.availabilityActive || available < 0 || available === 0 || unavailable <= 0 || !pageSize) {
          return;
        }
        const page = Math.max(1, parseInt(new URL(href, window.location.origin).searchParams.get("page"), 10) || 1);
        const start = (page - 1) * pageSize;
        const fromAvailable = start < available ? Math.min(pageSize, available - start) : 0;
        const needUnavailable = pageSize - fromAvailable;
        const jobs = [];
        if (fromAvailable > 0) {
          jobs.push(this._oosFetch(href, { "filter.v.availability": "1", page: String(page) }).then((div) => ({ key: "A", div })));
        }
        const unavailableStart = Math.max(0, start - available);
        if (needUnavailable > 0 && unavailableStart < unavailable) {
          const firstPage = Math.floor(unavailableStart / pageSize) + 1;
          const lastPage = Math.floor((unavailableStart + needUnavailable - 1) / pageSize) + 1;
          for (let p = firstPage; p <= lastPage; p++) {
            jobs.push(this._oosFetch(href, { "filter.v.availability": "0", page: String(p) }).then((div) => ({ key: "B", page: p, div })));
          }
        }
        const results = await Promise.all(jobs);
        let items = [];
        const resultA = results.find((r) => r.key === "A");
        if (resultA) {
          items = this._oosItems(resultA.div).slice(0, fromAvailable);
        }
        const resultsB = results.filter((r) => r.key === "B").sort((a, b) => a.page - b.page);
        if (resultsB.length) {
          const offset = unavailableStart - (resultsB[0].page - 1) * pageSize;
          let itemsB = [];
          resultsB.forEach((r) => { itemsB = itemsB.concat(this._oosItems(r.div)); });
          // Produkte mit lieferbarer und ausverkaufter Variante stehen in beiden Listen; hier nur echte Ausverkaufte
          itemsB = itemsB.slice(offset, offset + needUnavailable).filter((item) => item.classList.contains("product-item--sold-out"));
          items = items.concat(itemsB);
        }
        const inner = fakeDiv.querySelector("#facet-main .product-list__inner");
        if (inner && items.length) {
          inner.replaceChildren(...items);
        }
      }
      async _rerender(event) {
        const isInitial = !!(event && event.oosInitial);
        if (!isInitial) {
          history.replaceState({}, "", event.detail.url);
        }
        this._abort();
        this.showLoadingBar();
        const href = window.location.href;
        try {
          this.abortController = new AbortController();
          const fakeDiv = await this._oosFetch(href);
          if (this._oosShouldSplit(href)) {
            try {
              await this._oosApply(fakeDiv, href);
            } catch (e) {
              if (e.name === "AbortError") {
                throw e;
              }
              // Fallback: Shopify-Standardreihenfolge anzeigen
            }
          }
          this.querySelector("#facet-main").innerHTML = fakeDiv.querySelector("#facet-main").innerHTML;
          const activeFilterList = Array.from(fakeDiv.querySelectorAll(".product-facet__active-list")), toolbarItem = document.querySelector(".mobile-toolbar__item--filters");
          if (toolbarItem) {
            toolbarItem.classList.toggle("has-filters", activeFilterList.length > 0);
          }
          const filtersTempDiv = fakeDiv.querySelector("#facet-filters");
          if (filtersTempDiv && this.querySelector("#facet-filters")) {
            const previousScrollTop = this.querySelector("#facet-filters .drawer__content").scrollTop;
            Array.from(this.querySelectorAll("#facet-filters-form .collapsible-toggle[aria-controls]")).forEach((filterToggle) => {
              const filtersTempDivToggle = filtersTempDiv.querySelector(`[aria-controls="${filterToggle.getAttribute("aria-controls")}"]`), isExpanded = filterToggle.getAttribute("aria-expanded") === "true";
              if (!filtersTempDivToggle) {
                return;
              }
              filtersTempDivToggle.setAttribute("aria-expanded", isExpanded ? "true" : "false");
              filtersTempDivToggle.nextElementSibling.toggleAttribute("open", isExpanded);
              filtersTempDivToggle.nextElementSibling.style.overflow = isExpanded ? "visible" : "";
            });
            this.querySelector("#facet-filters").innerHTML = filtersTempDiv.innerHTML;
            this.querySelector("#facet-filters .drawer__content").scrollTop = previousScrollTop;
          }
          if (!isInitial) {
            const scrollTo = this.querySelector(".product-facet__meta-bar") || this.querySelector(".product-facet__product-list") || this.querySelector(".product-facet__main");
            requestAnimationFrame(() => {
              scrollTo.scrollIntoView({ block: "start", behavior: "smooth" });
            });
          }
          this.hideLoadingBar();
        } catch (e) {
          if (e.name === "AbortError") {
            return;
          }
          this.hideLoadingBar();
        } finally {
          this.setAttribute("data-oos-ready", "");
        }
      }
      _abort() {
        if (this.abortController) {
          this.abortController.abort();
        }
      }
    };
    window.customElements.define("product-facet", ProductFacet);

    // js/custom-element/section/facet/facet-filters.js
    const DrawerContent = window.customElements.get("drawer-content");
    var FacetFilters = class extends DrawerContent {
      connectedCallback() {
        super.connectedCallback();
        this.delegate.on("change", '[name^="filter."]', this._onFilterChanged.bind(this));
        this.rootDelegate.on("click", '[data-action="clear-filters"]', this._onFiltersCleared.bind(this));
        if (this.alwaysVisible) {
          this.matchMedia = window.matchMedia(window.themeVariables.breakpoints.pocket);
          this.matchMedia.addListener(this._adjustDrawer.bind(this));
          this._adjustDrawer(this.matchMedia);
        }
      }
      get alwaysVisible() {
        return this.hasAttribute("always-visible");
      }
      _onFiltersCleared(event, target) {
        event.preventDefault();
        this.dispatchEvent(new CustomEvent("facet:criteria-changed", { bubbles: true, detail: { url: target.href } }));
      }
      _onFilterChanged() {
        const formData = new FormData(this.querySelector("#facet-filters-form"));
        const searchParamsAsString = new URLSearchParams(formData).toString();
        this.dispatchEvent(new CustomEvent("facet:criteria-changed", { bubbles: true, detail: { url: `${window.location.pathname}?${searchParamsAsString}` } }));
      }
      _adjustDrawer(match) {
        this.classList.toggle("drawer", match.matches);
        this.classList.toggle("drawer--from-left", match.matches);
      }
    };
    window.customElements.define("facet-filters", FacetFilters);

    // js/custom-element/section/facet/sort-by-popover.js
    const PopoverContent = window.customElements.get("popover-content");
    var SortByPopover = class extends PopoverContent {
      connectedCallback() {
        super.connectedCallback();
        this.delegate.on("change", '[name="sort_by"]', this._onSortChanged.bind(this));
      }
      _onSortChanged(event, target) {
        const currentUrl = new URL(location.href);
        currentUrl.searchParams.set("sort_by", target.value);
        currentUrl.searchParams.delete("page");
        this.open = false;
        this.dispatchEvent(new CustomEvent("facet:criteria-changed", {
          bubbles: true,
          detail: {
            url: currentUrl.toString()
          }
        }));
      }
    };
    window.customElements.define("sort-by-popover", SortByPopover);

    // js/custom-element/ui/price-range.js
    var PriceRange = class extends HTMLElement {
      connectedCallback() {
        this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child");
        this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child");
        this.textInputLowerBound = this.querySelector(".price-range__input:first-child input");
        this.textInputHigherBound = this.querySelector(".price-range__input:last-child input");
        this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select());
        this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select());
        this.textInputLowerBound.addEventListener("change", (event) => {
          event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
          this.rangeLowerBound.value = event.target.value;
          this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max) * 100}%`);
        });
        this.textInputHigherBound.addEventListener("change", (event) => {
          event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
          this.rangeHigherBound.value = event.target.value;
          this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max) * 100}%`);
        });
        this.rangeLowerBound.addEventListener("change", (event) => {
          this.textInputLowerBound.value = event.target.value;
          this.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
        });
        this.rangeHigherBound.addEventListener("change", (event) => {
          this.textInputHigherBound.value = event.target.value;
          this.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
        });
        this.rangeLowerBound.addEventListener("input", (event) => {
          this.dispatchEvent(new CustomEvent("facet:abort-loading", { bubbles: true }));
          event.target.value = Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1);
          event.target.parentElement.style.setProperty("--range-min", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
          this.textInputLowerBound.value = event.target.value;
        });
        this.rangeHigherBound.addEventListener("input", (event) => {
          this.dispatchEvent(new CustomEvent("facet:abort-loading", { bubbles: true }));
          event.target.value = Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1);
          event.target.parentElement.style.setProperty("--range-max", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
          this.textInputHigherBound.value = event.target.value;
        });
      }
    };
    window.customElements.define("price-range", PriceRange);
  }
  if (window.criticalLoaded) { init() }
  else { document.addEventListener("critical-js:loaded", init); }
})();